import { Component, inject, Input, OnInit } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { getIsExperienceEditorActive } from '@core/jss-routing';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getDroplinkValue, getFieldValue, mockForXp } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import { reviewActions, selectSingleReview } from '@reviews/entity';
import type {
  GetReviewsResponseReview,
  GetReviewsV1Data,
} from '@integration/api-client/reviews';

import { mockReview } from '../reviews.mock';

@Component({
  selector: 'wl-review-single-legacy-container',
  templateUrl: './review-single-container.component.html',
  styleUrls: [],
})
export class ReviewSingleContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  public isManualReview = false;

  readonly store$ = inject(Store);

  xpEditorActive$ = this.store$.select(getIsExperienceEditorActive);

  review$ = mockForXp<GetReviewsResponseReview | undefined>(
    this.xpEditorActive$,
    this.store$.select(selectSingleReview),
    mockReview
  );

  ngOnInit() {
    this.initializeContent();
  }

  get location() {
    const input = getDroplinkValue(this.rendering?.fields, 'reviewCategory');
    return input || undefined;
  }

  private initializeContent(): void {
    this.isManualReview = getFieldValue(
      this.rendering,
      'IsManualReview',
      false
    );

    if (!this.isManualReview) {
      const lastReviewPayload: GetReviewsV1Data = {
        page: 1,
        amountOfReviews: 1,
        location: this.location as GetReviewsV1Data['location'],
      };

      this.store$.dispatch(
        reviewActions.getReviewsV1.requestAction({
          actionId: 'review-single',
          payload: lastReviewPayload,
        })
      );
    }
  }

  get manualReview(): GetReviewsResponseReview {
    return {
      id: '',
      author: getFieldValue(this.rendering, 'Name', ''),
      title: getFieldValue(this.rendering, 'Title', ''),
      content: getFieldValue(this.rendering, 'Description', ''),
      city: getFieldValue(this.rendering, 'Location', ''),
      date: getFieldValue(this.rendering, 'Date', ''),
      rating: Number(getFieldValue(this.rendering, 'Score')),
      wouldRecommend: false,
    };
  }
}
